import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// misc components
import { CharacterCountComponent } from './components/character-count/character-count.component';

const exportComponents = [CharacterCountComponent];

@NgModule({
  imports: [
    CommonModule,
    ...exportComponents,
  ],
  exports: [
    ...exportComponents,
  ],
})
export class MiscModule { }
